export const isMobile = () => {
  const userAgentCheck = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  const screenCheck = window.matchMedia("(pointer: coarse)").matches
  return userAgentCheck || screenCheck
}
